// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "groupfolders-" + chunkId + ".js?v=" + {"vendors-node_modules_vue-material-design-icons_Cancel_vue-node_modules_vue-material-design-ic-b73635":"98a0d5e400202e6c790d","sharing":"af56b26d9008f159ff9f"}[chunkId] + "";
};